export default __webpack_public_path__ + "static/media/f1.54efa159.png";